module.exports = __webpack_public_path__ + "static/media/main-icon.b87862fc.svg";